module.exports = __webpack_public_path__ + "static/teleco_25-f086eba3b07e374bd899df6f1dc27f28.jpg";